// Generated from icons/raw/loading.svg by scripts/generate-icons.mjs. Do not edit.
import type { SVGProps } from "react";

export function LoadingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 14 14"
      width={16}
      height={16}
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path d="M1.75 6.99999C1.75005 5.89131 2.10109 4.81111 2.75279 3.9142C3.40449 3.01729 4.3234 2.34971 5.37782 2.00715C6.43225 1.66458 7.56805 1.66461 8.62246 2.00724C9.67686 2.34986 10.5957 3.01749 11.2474 3.91444C11.899 4.81139 12.25 5.89161 12.25 7.00028C12.25 8.10896 11.899 9.18917 11.2473 10.0861C10.5957 10.9831 9.6768 11.6507 8.62239 11.9933C7.56798 12.3359 6.43217 12.3359 5.37775 11.9933" stroke="currentColor" strokeWidth="1.14" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
